export default __webpack_public_path__ + "static/media/ic_star.735af80a.svg";